import React from "react"
import { Link as GatsbyLink } from "gatsby"
import { Box, Flex, Heading, Text, Link } from "@chakra-ui/react"
import {
  ALL_STAR_MAIL_LINK,
  ALL_STAR_PAGES_URL,
  AGH_NETWORK,
} from "../../../../../constants/constants"

const styles = {
  root: {
    width: "100%",
    px: { base: "16px", md: "24px", lg: "24px" },
    bg: "#F4F7FF",
    justifyContent: "center",
  },
  content: {
    my: { base: "24px", md: "24px", lg: "60px" },
    width: "1080px",
  },
  "inner-box": {
    p: { base: "20px", md: "36px", lg: "36px" },
    maxWidth: "764px",
    bg: "#FFFFFF",
    boxShadow: "0px 8px 12px 0px #2D37480D",
    borderRadius: "8px",
  },
  heading: {
    fontSize: "24px",
    fontWeight: 700,
    lineHeight: "32px",
  },
  title: {
    fontSize: { base: "18px", md: "18px", lg: "24px" },
    fontWeight: 700,
    lineHeight: { base: "21.48px", md: "21.48px", lg: "32px" },
  },
  note: {
    fontSize: "16px",
    fontStyle: "italic",
    fontWeight: "bold",
    lineHeight: "24px",
    color: "#6E7E99",
  },
  text: {
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "24px",
    color: "#2D3748",
  },
  link: {
    fontSize: "16px",
    color: "#3399FF",
    fontWeight: 400,
    lineHeight: "24px",
  },
}

const PressRelease2025 = ({ year }) => {
  return (
    <Flex sx={styles.root}>
      <Box sx={styles.content}>
        <Box sx={styles["inner-box"]}>
          <Heading sx={styles.heading}>Press Release Template</Heading>
          <Text sx={{ fontWeight: "bold", mt: "10px" }}>[DATE]</Text>
          <Heading sx={styles.title} color="#129459" pt="20px">
            [Hospital Name] is Named to the List of [Specialty] Research
            All-Stars for 2025
          </Heading>

          <Text sx={styles.note} mt="20px">
            The All-Star lists include only the top 5% of hospitals and surgeons
            publishing leading-edge healthcare research.
          </Text>

          <Text sx={styles.text} mt="20px">
            <strong>[City, State, Date]</strong> - [Hospital Name] is proud to
            announce our inclusion as one of the [Specialty] Research All-Stars
            for 2024-2025. This honor is in recognition of the quantity and
            quality of the orthopedic research authored and published by our
            surgeons.
          </Text>

          <Text sx={styles.text} mt="20px">
            The Healthcare Research All-Star lists are compiled by Avant-garde
            Health and include only the top 5% of hospitals and surgeons
            publishing leading-edge research in [specialty] care.
          </Text>

          <Text sx={styles.text} mt="20px">
            [Hospital executive quote here]
          </Text>

          <Text sx={styles.text} mt="20px">
            This honor recognizes the top 5% of hospitals and surgeons in the
            United States publishing leading-edge research in{" "}
            <strong>[Specialty]</strong> care, which ultimately leads to better
            patient outcomes. More than 424,000 physicians and 4,700 hospitals
            were considered for the awards, sponsored by{" "}
            <Link color="#3399FF" as={GatsbyLink} to={"/"}>
              Avant-garde Health
            </Link>
            , the leading provider of solutions for improving perioperative
            quality and profitability.
          </Text>

          <Box mt="20px">
            <Text sx={styles.text}>
              To determine the award winners, Avant-garde Health examined both
              the quantity and quality of research by surgeons and hospitals.
              The study methodology can be reviewed{" "}
              <Link
                color="#3399FF"
                as={GatsbyLink}
                to={"/" + ALL_STAR_PAGES_URL.METHODOLOGY + "/"}
              >
                Here
              </Link>
              , as well as the{" "}
              <Link
                color="#3399FF"
                as={GatsbyLink}
                to={"/" + ALL_STAR_PAGES_URL.KEY_FINDINGS + "/"}
              >
                Key Findings
              </Link>{" "}
              from the study.
            </Text>
          </Box>

          <Box mt="20px">
            <Text sx={styles.text}>[Hospital executive quote here]</Text>
            <Text sx={styles.text}>
              “We are excited to include <strong>[Hospital Name]</strong> in our
              inaugural list of <strong>[Specialty]</strong> Research All-Stars
              for 2025,” said Derek Haas, CEO and Founder of Avant-garde Health.
              “This ground-breaking study examined the research of more than
              <strong>[NN]</strong> hospitals and <strong>[NN]</strong> surgeons
              and includes only the top five percent based on the quantity and
              quality of their published research. We are grateful for their
              dedication and contributions to improvements in{" "}
              <strong>[specialty]</strong> care and honored to highlight their
              achievements in this study.”
            </Text>
            <Text sx={{ mt: "20px" }}></Text>
            <Text>
              The full study results can be reviewed{" "}
              <Link
                color="#3399FF"
                as={GatsbyLink}
                to={"/" + ALL_STAR_PAGES_URL.HOME + "/"}
              >
                Here
              </Link>{" "}
              .
            </Text>
          </Box>

          <Box sx={{ mt: "20px" }}>
            <Text sx={{ fontWeight: "bold" }}>About [Hospital Name]</Text>
            <Text sx={{ fontWeight: "normal" }}>TBD</Text>
          </Box>

          <Box sx={{ mt: "20px" }}>
            <strong>About Avant-garde Health</strong>
            <Text sx={styles.text}>
              Avant-garde Health provides hospitals, surgery centers, and
              physicians with AI driven analytics and step by step action plans
              to improve the cost, quality, and efficiency of surgical care. Our
              platform delivers granular, actionable data-enabling providers to
              uncover opportunities for operational and financial improvement
              that are often hidden in traditional reporting systems.They
              collaborate closely with clinicians to publish impactful,
              data-driven research.
              <br />
              Recent work has been featured in leading journals including
              Harvard Business Review, The New England Journal of Medicine, and
              JAMA. To learn more, please visit{" "}
              <Link sx={styles.link} isExternal href={AGH_NETWORK.WEBSITE}>
                avantgardehealth.com
              </Link>
              .
            </Text>
          </Box>

          <Box mt="20px">
            <Text
              sx={{
                fontWeight: "bold",
                fontSize: "16px",
                lineHeight: "24px",
                color: "#2D3748",
                mb: "10px",
              }}
            >
              [Hospital Name] Contact
            </Text>
            <Text sx={styles.text}>name</Text>
            <Text sx={styles.text}>Title</Text>
            <Text sx={styles.text}>Phone</Text>
            <Text sx={styles.text}>E-mail</Text>
          </Box>
          <Box mt="20px">
            <Text sx={styles.text}>
              <strong>Avant-garde Health Contact</strong>
            </Text>
            <Text sx={styles.text}>Porter Jones, MD</Text>
            <Text sx={styles.text}>Chief Medical Officer</Text>
            <Text sx={styles.text}>801.598.3921</Text>
            <Text sx={styles.text}>
              <Link
                sx={styles.link}
                href="mailto:porter@avantgardehealth.com
"
              >
                porter@avantgardehealth.com
              </Link>
            </Text>
          </Box>
        </Box>
        <Text sx={styles.text} mt="40px" maxW="590px">
          If you have any questions or difficulty with the press release
          template, please contact us at{" "}
          <Link sx={styles.link} href={ALL_STAR_MAIL_LINK}>
            Research.All-Stars@avantgardehealth.com
          </Link>
          .
        </Text>
      </Box>
    </Flex>
  )
}

export default PressRelease2025
